<template>
  <div style="margin-top: 2rem">

    <h5 class="mb-4">
      <span >TOA Total: </span>
      <b-badge>{{monthTotal}}</b-badge>
    </h5>

    <b-row v-if="shoppingPartnerItems.length > 0" class="mr-0 mt-4">
      <b-col>
        <h5 class="mt-4" style="margin-bottom: 2rem; margin-top: 2rem;">Partner Totals</h5>

        <b-table class="mt-3" :items="shoppingPartnerItems" :fields="partnerFields" ref="table" striped :per-page="perPagePartner" :current-page="currentPagePartner">
        </b-table>

        <div v-if="perPagePartner" class="d-flex justify-content-center">
          <b-pagination :total-rows="shoppingPartnerItems.length" :per-page="perPagePartner" v-model="currentPagePartner"/>
        </div>
      </b-col>
      <b-col>
      </b-col>
    </b-row>


    <h5 style="margin-top: 4rem">Records</h5>
    <div id="user-count-stats" class="d-flex justify-content-between align-items-center my-4">
      <b-form inline class="">
        <label class="mr-sm-2" for="rev-share-select-partner">Partner</label>
        <b-form-select class="mr-2" id="rev-share-select-partner" :value="selectedPartner" @input="updatePartner($event)" :options="partnerOptions"></b-form-select>
      </b-form>

      <b-button v-if="false" variant="primary" @click="exportRecords">
        <Icon icon="export"/>
        Export Records
      </b-button>
    </div>


    <b-table class="mt-3" :items="shoppingItems" :fields="compensationFields" ref="table" @row-clicked="handleSelectedRow" striped hover small :per-page="perPage" :current-page="currentPage"/>

    <div v-if="perPage" class="d-flex justify-content-center">
      <b-pagination :total-rows="shoppingItems.length" :per-page="perPage" v-model="currentPage"/>
    </div>

    <ShoppingDetailsModal ref="shoppingDetailsModal"/>

    <iframe id="export-shoppings-frame" style="display:none;"></iframe>
  </div>
</template>

<script>
import ShoppingDetailsModal from './ShoppingDetailsModal.vue'

export default {
  name: 'ShoppingOverview',

  components: {
    ShoppingDetailsModal
  },

  data: function() {
    return {
      partnerFields: [
         {key: 'partner_name', label: 'Partner', sortable: true},
         {key: 'quantity', label: 'Quantity', sortable: true, tdClass: "text-right"},
         {key: 'partner_amount', label: 'Billable Amount (€)', sortable: true, formatter: this.$helpers.currencyFormatter, tdClass: "text-right"},
         {key: 'platform_amount', label: 'TOA Amount (€)', sortable: true, formatter: this.$helpers.currencyFormatter, tdClass: "text-right"}
      ],

      compensationFields: [
         {key: 'media_id', label: 'ID', sortable: true},
         {key: 'media_title', label: 'Ttitle', sortable: true},
         {key: 'partner_name', label: 'Partner', sortable: true},
         {key: 'type', label: 'Type', sortable: true},
         {key: 'quantity', label: 'Quantity', sortable: true},
         {key: 'partner_amount', label: 'Billable Amount (€)', sortable: true, formatter: this.$helpers.currencyFormatter, tdClass: "text-right"},
         {key: 'platform_amount', label: 'TOA Amount (€)', sortable: true, formatter: this.$helpers.currencyFormatter, tdClass: "text-right"},
         {key: 'total_amount', label: 'Total Amount (€)', sortable: true, formatter: this.$helpers.currencyFormatter, tdClass: "text-right"},
      ],

      currentPage: 1,
      perPage: 20,

      currentPagePartner: 1,
      perPagePartner: 20,

      partnerOptions: [],
      selectedPartner: "__all__"

    };
  },

  computed: {
    monthTotal() {
      let total = 0
      this.shoppingPartnerItems.forEach(item => total += item.platform_amount)

      return this.$helpers.currencyFormatter(total)
    },

    selectedYear() {
      return this.$store.state.finance.selectedYear
    },

    selectedMonth() {
      return this.$store.state.finance.selectedMonth
    },

    shoppingItems() {
      return this.$store.state.finance.shoppingItems.filter(rec => (this.selectedPartner == "__all__") || (rec.partner_id == this.selectedPartner))
    },

    shoppingPartnerItems() {
      return this.$store.state.finance.shoppingPartnerItems.filter(item => item.total_amount != 0 || item.quantity != 0)
    },
},

  methods: {
    getProviderOptions() {
      fetch("/admin/api/v2/partners/select-options?include-all")
      .then(this.$helpers.JSONHandler)
      .then(resp => {
        this.partnerOptions = resp.data
      });
    },

    updatePartner(partner_id) {
      this.selectedPartner = partner_id
    },

    handleSelectedRow(row) {
      this.$refs.shoppingDetailsModal.show(row.title, row.skus)
    },

    exportRecords() {
      let payload = {
        data: {
          year: this.selectedYear,
          month: this.selectedMonth,
          partner_id: this.selectedPartner
        }
      }

      this.$http.postJSON(
        "/admin/api/v2/shoppings/build-export",
        payload,
        (resp) => {
          let file_name = "/admin/api/v2/shoppings/download-export/" + resp.data;
          document.getElementById('export-shoppings-frame').src = file_name;
        },
        (status, html) => {
          this.clear()
          this.$root.app.showErrorDialog(html, status.toString())
        }
      )
    },
  },

  created() {
    this.getProviderOptions()
    this.$root.$on('rev-share-update', this.update)
  },

  beforeDestroy() {
    this.$root.$off('rev-share-update', this.update)
  }
}
</script>

<style scoped>
</style>
